import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Button } from 'react-bootstrap';
import ProfilePhoto from '../../../../styles/images/profile-photo.png';
import BackIcon from '../../../../styles/images/back.png';
import BackRawIcon from '../../../../styles/images/back-without-bg.png';
import { handleChangeDataBottomSheet } from '../../../../redux/actions/partials/footer/bottom_sheet';

const BuyOrgUser = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { profile } = useSelector(state => state.user);

    const closeBottomSheet = () => {
        dispatch(handleChangeDataBottomSheet('isOpen', false));
    };

    const handleBackBtn = () => {
        navigate(-1);
    };

    return (

        <div id="buy-normal-user-page" onClick={closeBottomSheet} className="pb-5" >

            <Row className="py-3 white-bg sticky top-0 z-index-2">
                <Col xs={1}><img src={BackRawIcon} alt="back" onClick={handleBackBtn} /></Col>
                <Col xs={10}><h4 className="text-center">خرید با کیف پول سیتگ</h4></Col>
                <Col xs={1}></Col>
            </Row>


            {/*<h6 style={{marginTop: "4rem"}}>کاربر عزیز</h6>*/}
            <div className="font-weight-300 mt-4 text-justify">
                برای پرداخت خریدهای حضوری و تلفنی از فروشگاه های طرف قرارداد میتوانید از یکی از این دو روش استفاده کنید:
                <ul className="mt-3">
                    <li>
                        <strong>انتقال وجه: </strong> با این روش میتوانید مبلغ خرید خود را از کیف پول خود به فروشگاه انتقال دهید.
                    </li>
                    <li className="mt-2">
                        <strong>ایجاد بارکد: </strong> با ایجاد بارکد و نمایش آن به صندوقدار، مبلغ خرید شما توسط صندوقدار از کیف پول شما کسر  میگردد
                    </li>
                </ul>
            </div>

            
            <div className="primary-border p-3 mt-5">
                <Row className="font-weight-200">
                    <Col xs={12} className="d-flex">
                        <div >
                            موجودی کیف پول سازمانی:
                        </div>
                        <div className="ml-2">
                            {profile.user_org_credit.toLocaleString()} ریال
                        </div>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col xs={12} className="d-flex align-items-center">
                        <span className="text-left w-100 font-size-10" style={{whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden"}}>قابل استفاده در فروشگاه های هایپرلند، نگین فارس ....</span>
                        <img src={BackIcon} width={30} style={{rotate: "180deg"}} />
                    </Col>
                </Row>
            </div>


            <div className="primary-border p-3 mt-3" >
                <Row className="font-weight-200">
                    <Col xs={6} className="text-center">
                        موجودی کیف پول:
                    </Col>
                    <Col xs={6} className="text-center">
                        {profile.user_credit.toLocaleString()} ریال
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col xs={12}>
                        <Link to="../charge-wallet">
                            <Button className="primary-border bg-secondary primary-txt-color font-weight-300 radius-12 w-100 py-2">
                                افزایش موجودی
                            </Button>
                        </Link>
                    </Col>
                </Row>
            </div>

            <Row className="mt-4">
                <Col xs={12}>
                    <Link to="../transfer/search">
                        <Button className="primary-btn radius-12 w-100 py-2">
                            انتقال وجه از کیف پول به فروشگاه
                        </Button>
                    </Link>
                </Col>
                <Col xs={12} className="mt-3">
                    <Link to="../barcode_generate">
                        <Button className="primary-btn radius-12 w-100 py-2">
                            ایجاد بارکد جهت پرداخت
                        </Button>
                    </Link>
                </Col>
            </Row>


            

            
        </div>

    );
}

export default BuyOrgUser;